import React, { useEffect } from "react";
import AddressSession from "../session/AddressSession";
import IngredientList from "../components/ingredient/IngredientList";

import "../style/Session.css";
import { useDispatch, useSelector } from "react-redux";
import { IMAGES } from "../utils/utils";
import usePageSetup from "../hooks/usePageSetup";
import { motion } from "framer-motion";
import LoadingBackdrop from "../components/skeleton/LoadingBackdrop";
import { slideUp } from "../utils/animationUtils";
import XoiComHeading from "../components/generics/XoiComHeading";
import { fetchIngredientLocations } from "../api/ingredient/ingredient.reduxThunk";
import {
  setActiveLocationEmpty,
  setIngredientPreview,
} from "../api/xoicom.reducer";

function Ingredient() {
  usePageSetup("light");

  const dispatch = useDispatch();
  const ingredientText = useSelector((state) => state.reducer.ingredientText);
  const loading = useSelector((state) => state.reducer.loading);
  const language = useSelector((state) => state.reducer.language);

  useEffect(() => {
    dispatch(fetchIngredientLocations());
    dispatch(setActiveLocationEmpty());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setIngredientPreview());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  return (
    <div>
      <LoadingBackdrop open={loading} />
      <div className="landing-session">
        <img
          className="landing-image"
          src={IMAGES.INGREDIENT_LANDING}
          alt="ingredient-landing"
        />
        <motion.div
          className="landing-text"
          style={{ maxWidth: 700 }}
          variants={slideUp}
          initial="initial"
          whileInView="animate"
          viewport={{ once: true }}
        >
          <XoiComHeading
            heading={ingredientText.landingText}
            textColor="white"
            bigHeader
          />
        </motion.div>
      </div>
      <IngredientList ingredientText={ingredientText} language={language} />
      <AddressSession mode="cta" />
    </div>
  );
}

export default Ingredient;
